import { post } from './http'
import global from '@/api/global'
var name = global.zhbPanel
// ---------------基础管理---------------------
// 基础管理--字典数据
export const TenantDictionary = p => post(name + '/dictionary/getDictionary', p)
// 基础管理-查询
export const jiChuGuanLiChaXun = p => post(name + '/contractInfo/list', p)
// 基础管理-修改
export const jiChuGuanLiChange = p => post(name + '/contractInfo/update', p)
// 基础设置-修改-车队下拉框
export const jiChuGuanLiChangeFleet = p => post(name + '/crmApi/getCustomerDataByTruck', p)
// ---------------计划管理---------------------
// 计划管理-查询
export const tCollectPlanSeatch = p => post(name + '/tCollectPlan/list', p)
// 计划管理-新增-选择合同
export const tCollectPlanSeatchHeTong = p => post(name + '/tCollectPlan/queryContractInfoByPlanAdd', p)
// 计划管理-新增
export const tCollectPlanAdd = p => post(name + '/tCollectPlan/add', p)
// 计划管理-修改
export const tCollectPlanChange = p => post(name + '/tCollectPlan/update', p)
// 计划管理-发布
export const tCollectPlanRelease = p => post(name + '/tCollectPlan/updateByPlanStatus', p)
// 计划管理-取消发布
export const tCollectPlanQuXiaoRelease = p => post(name + '/tCollectPlan/updateByPlanStatusRevoke', p)
// 计划管理-删除
export const deletePlan = p => post(name + '/tCollectPlan/deletePlan', p)
// 计划管理-集港Tab页-点击派车
export const getManualDispatchCarInfo = p => post(name + '/tCollectPlan/getManualDispatchCarInfo', p)
// ---------------派车管理---------------------
// 派车管理-获取垛位信息
export const paiCheDuoWeiData = p => post(name + '/t/waybill/addData', p)
// 派车管理-选择车辆数据
export const paiCheGetCarAndDriver = p => post(name + '/t/waybill/changeCarAndDriver', p)
// 派车管理- 完成派车
export const paiCheFinish = p => post(name + '/t/waybill/saveAllData', p)
// 单合同派车-派车详情
export const paiXiangQing = p => post(name + '/t/waybill/listDataByOneContractNo', p)
// 单合同派车-撤销派车
export const cheXiaoPaiChe = p => post(name + '/t/waybill/revokeWaybillData', p)
// ---------------运单管理---------------------
// 运单管理-查询
export const yunDanGuanLi = p => post(name + '/t/waybill/listAllWaybill', p)
// 运单管理详情
export const yunDanGuanLiXiangQing = p => post(name + '/t/load/detail/listByWaybillNo', p)
// 运单管理-还原车辆
export const restoreVehicle = p => post(name + '/t/waybill/restoreVehicle', p)
// 撤销审核
export const cheXiaoShenHe = p => post(name + '/t/waybill/listRevokeWaybillData', p)
// 审核通过/审核不通过
export const shenHeAuditFlag = p => post(name + '/t/waybill/updataWaybillByAuditFlag', p)
// ----------------统计分析---------------------
// 统计接口外发
export const tongJiFenXiWaiFa = p => post(name + '/tCollectPlan/statisticsBySengOut', p)
// 统计接口集港
export const tongJiFenXiJiGang = p => post(name + '/tCollectPlan/statisticsByGatheringPort', p)
// ----------------自动派车设置与查询---------------------
// 停止自动派车
export const stopAutoDispatcherCar = p => post(name +'/autoDispatcherCar/stop')
// 启动自动派车
export const startAutoDispatcherCar = p => post(name + '/autoDispatcherCar/start')
// 自动派车的状态
export const autoDispatcherCarStatus = p => post(name + '/autoDispatcherCar/status')
// ----------------集港手动派车---------------------
// 获取车辆信息
export const getSelectVehicleInfo = p => post(name + '/t/waybill/getSelectVehicleInfo',p)
// 完成派车
export const  cyManualSendCar = (params,planId) => post (name + `/t/waybill/cyManualSendCar/${planId}`,params)
// 获取大计划信息   
export const  getBigPlanInfo = (planNo) => post (name + `/tCollectPlan/getBigPlanInfo/${planNo}`)
// 1.4版派车   
export const  bigPlanManualSendCar = (planNo,params) => post (name + `/t/waybill/bigPlanManualSendCar/${planNo}`,params)
// 集港大计划 计划详情
export const getPlanDetail = p => post(name + '/tCollectPlan/getPlanDetail', p)

//--------------------------1.5版-----------------------------
// 计划管理
// 计划列表  
export const planInfo = p => post(name + '/tCollectPlan/planInfo', p)
// 计划管理-完成/未完成         
export const planComplete = p => post(name + '/tCollectPlan/complete', p)
// 计划列表-统计量   
export const statisticForPlanManage = p => post(name + '/tCollectPlan/statisticForPlanManage', p)
// 计划详情  
export const detailList = p => post(name + '/t/cplan/detail/list', p)
// 计划详情-已开交货统计  
export const statisticsPlanDetail = p => post(name + '/t/cplan/detail/statistics/planDetail', p)
// 计划详情-交货单  
export const  deliverList = (ids) => post (name + `/t/cplan/detail/deliverList/${ids}`)
// 计划详情-出货量  
export const loadDetailList = p => post(name + '/t/cplan/detail/loadDetailList', p)
// 计划详情-按合同汇总   
export const  baseContract = p => post(name + '/t/cplan/detail/baseContract', p)
// 计划详情-按合同汇总-出货详情  
export const  loadDetailListByContract = p => post(name + '/t/cplan/detail/loadDetailListByContract', p)
// 基础设置-修改  
export const modifyContract = (wayBillFlag,params) => post(name + `/contractInfo/modifyContract/${wayBillFlag}`, params)
// 运单管理--列表凭证查看  
export const  receiptImg = (id) => post (name + `/t/waybill/receipt/image/${id}`)
// 计划列表点击运单  
export const  wayBillList = p => post(name + '/tCollectPlan/wayBillList', p)
// 入库作业-同步-获取货物详情 
// export const  getLoadDetailListByLoadNo = p => post(name + '/t/load/detail/getByLoadNo', p)
export const  getLoadDetailListByLoadNo = p => post(name + '/temp/zhb/loadbill/getByLoadNo', p)